import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserInfo } from 'src/app/core/models/login.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { DialogNewComponent } from 'src/app/shared/components/dialog-new/dialog-new.component';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { HubConnection, HubConnectionBuilder, IHttpConnectionOptions, LogLevel } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { ConnectComponentService } from 'src/app/core/services/connectcomponent.service';
import { environment } from 'src/environments/environment';
import { NotificationRepository } from 'src/app/core/repositories/notification.repository';
import { DialogPhimtatComponent } from './dialog-phimtat/dialog-phimtat.component';
import { HostListener } from '@angular/core';

const apiUrl = environment.apiUrl;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('customContent') customContent!: TemplateRef<any>;
  private dialogRef!: MatDialogRef<DialogNewComponent>;
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  notifications: any[] = []; // Danh sách thông báo
  unreadCount: number = 0; // Số thông báo chưa đọc

  showFiller = false;
  infoUser: UserInfo = {};
  fullName: string = '';
  email: string = '';
  roleName: string = '';
  userInfo = new UserInfo();
  lang: string = '';

  currentTime: string = '';
  currentDay: string = '';

  dialogPhimTatRef: any = null;

  private timeInterval: any;
  private hubConnectionBuilder!: HubConnection;
  private reconnectAttempts: number = 0;
  private maxReconnectAttempts: number = 5;
  private reconnectDelay: number = 3000; // 3 giây

  constructor(private translateService: TranslateService, public dialog: MatDialog, private authService: AuthService, private connectService: ConnectComponentService, private notificationRepo: NotificationRepository) { }

  ngOnInit(): void {
    const currentToken = localStorage.getItem('access_token');
    if (currentToken != undefined) {
      this.initializeSignalRConnection();
    }
    this.lang = localStorage.getItem('lang') || 'vi';
    this.authService.getUserInfo().subscribe((user) => {
      this.userInfo = user;
    });

    // Cập nhật thời gian thực mỗi giây
    this.updateTime();
    this.timeInterval = setInterval(() => this.updateTime(), 1000);
  }

  logout() {
    // localStorage.clear();
    const rememberedUser = localStorage.getItem('rememberedUser');
    localStorage.clear();
    if (rememberedUser) {
      localStorage.setItem('rememberedUser', rememberedUser);
    }
  }

  updateTime() {
    const now = new Date();
    this.currentTime = now.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    const dayIndex = now.getDay();
    const day = now.getDate();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    let weekday = '';

    // Sử dụng key từ i18n
    switch (dayIndex) {
      case 0:
        weekday = this.translateService.instant('HEADER.CHUNHAT');
        break;
      case 1:
        weekday = this.translateService.instant('HEADER.THUHAI');
        break;
      case 2:
        weekday = this.translateService.instant('HEADER.THUBA');
        break;
      case 3:
        weekday = this.translateService.instant('HEADER.THUTU');
        break;
      case 4:
        weekday = this.translateService.instant('HEADER.THUNAM');
        break;
      case 5:
        weekday = this.translateService.instant('HEADER.THUSAU');
        break;
      case 6:
        weekday = this.translateService.instant('HEADER.THUBAY');
        break;
    }

    const thang = this.translateService.instant('HEADER.THANG');
    const nam = this.translateService.instant('HEADER.NAM');

    this.currentDay = `${weekday}, ${day} ${thang} ${month} ${nam} ${year}`;
  }

  /**
   * Khởi tạo kết nối SignalR
   * SignalR endpoint được xác định bằng URL: ${apiUrl}notify
   * - apiUrl: Base URL từ environment (ví dụ: https://localhost:44393/)
   * - notify: Tên của SignalR Hub trên server
   * 
   * Connection ID:
   * - Được server tự động tạo khi client kết nối thành công
   * - Mỗi client có một Connection ID duy nhất
   * - Connection ID được dùng để server gửi message đến client cụ thể
   * - Nếu Connection ID không tồn tại trên server → "The connection could not be found"
   */
  private initializeSignalRConnection(): void {
    const currentToken = localStorage.getItem('access_token');
    if (!currentToken) {
      console.warn('Không có access token, không thể kết nối SignalR');
      return;
    }

    // Log thông tin user để debug
    this.logUserInfoForDebug();

    // Kết nối với WebSocket (yêu cầu bắt buộc)
    // Sẽ thử negotiate trước, nếu fail thì thử direct WebSocket
    this.tryConnectWithWebSocket();
  }

  /**
   * Log thông tin user để debug vấn đề kết nối với non-Admin accounts
   */
  private logUserInfoForDebug(): void {
    try {
      const currentToken = localStorage.getItem('access_token');
      const userDataStr = localStorage.getItem('data');
      
      // Decode JWT token để xem claims (không verify, chỉ để debug)
      let tokenClaims: any = null;
      if (currentToken) {
        try {
          const tokenParts = currentToken.split('.');
          if (tokenParts.length === 3) {
            const payload = tokenParts[1];
            // Decode base64
            const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
            tokenClaims = decodedPayload;
          }
        } catch (e) {
          console.warn('Không thể decode token:', e);
        }
      }

      // Parse user data từ localStorage
      let userData: any = null;
      if (userDataStr) {
        try {
          userData = JSON.parse(userDataStr);
        } catch (e) {
          console.warn('Không thể parse user data:', e);
        }
      }

      console.log('🔍 [SignalR Debug] User Info:', {
        hasToken: !!currentToken,
        tokenLength: currentToken?.length,
        tokenClaims: tokenClaims ? {
          // Log một số claims quan trọng (ẩn thông tin nhạy cảm)
          sub: tokenClaims.sub,
          exp: tokenClaims.exp,
          iat: tokenClaims.iat,
          role: tokenClaims.role || tokenClaims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
          // Thêm các claims khác nếu cần
        } : null,
        userData: userData ? {
          code: userData.code,
          RoleMax: userData.RoleMax,
          RoleLevel: userData.RoleLevel,
          // Thêm các field khác nếu cần
        } : null,
        userInfo: this.userInfo ? {
          RoleMax: this.userInfo.RoleMax,
          RoleLevel: this.userInfo.RoleLevel,
        } : null,
        isAdmin: userData?.code === 'ADMIN' || this.userInfo?.RoleMax === 1
      });
    } catch (error) {
      console.error('❌ Lỗi khi log user info:', error);
    }
  }

  /**
   * Kết nối với WebSocket (yêu cầu bắt buộc)
   * Sử dụng negotiate để đảm bảo WebSocket hoạt động với load balancer/proxy
   */
  private tryConnectWithWebSocket(): void {
    const currentToken = localStorage.getItem('access_token');
    
    if (!currentToken) {
      console.error('❌ Không có access token để kết nối SignalR');
      return;
    }

    // Option 1: Thử với negotiate (khuyến nghị cho load balancer/proxy)
    // Bỏ skipNegotiation để SignalR negotiate trước, sau đó kết nối WebSocket
    // Điều này giúp server tạo connection ID đúng cách và hỗ trợ sticky sessions
    const options: IHttpConnectionOptions = {
      withCredentials: true,
      accessTokenFactory: () => {
        const latestToken = localStorage.getItem('access_token');
        if (!latestToken) {
          console.error('❌ Access token không tồn tại khi accessTokenFactory được gọi');
          return "";
        }
        console.log('🔑 [SignalR] Access token được sử dụng, length:', latestToken.length);
        return latestToken;
      },
      // BỎ skipNegotiation để SignalR negotiate trước
      // Negotiate giúp server tạo connection ID và hỗ trợ load balancer
      skipNegotiation: true,
      // Vẫn chỉ định WebSocket để đảm bảo chỉ dùng WebSocket
      transport: signalR.HttpTransportType.WebSockets
    };

    this.hubConnectionBuilder = new HubConnectionBuilder()
      .withUrl(`${apiUrl}notify`, 
        {accessTokenFactory: () => {
          return localStorage.getItem("access_token") || "";
        }}
      )
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          if (retryContext.previousRetryCount < 3) {
            return 3000 * Math.pow(2, retryContext.previousRetryCount);
          }
          return 30000;
        }
      })
      .build();

    this.setupSignalREventHandlers();

    // Kết nối với WebSocket (có negotiate)
    this.hubConnectionBuilder.start()
      .then(() => {
        console.log('✅ SignalR Connection started successfully with WebSocket!');
        console.log('📡 Connection ID:', this.hubConnectionBuilder.connectionId);
        console.log('🔌 Transport: WebSocket (with negotiate)');
        this.reconnectAttempts = 0;
        this.loadNotifications();
        
        // 🧪 TEST: Gửi thông báo test sau khi kết nối thành công
        // this.testSendNotification();
      })
      .catch(err => {
        console.error('❌ WebSocket connection failed:', err);
        console.error('❌ Error details:', {
          message: err?.message,
          name: err?.name,
          stack: err?.stack
        });
        
        // Log thông tin user khi connection fail để debug
        this.logUserInfoForDebug();
        
        this.handleConnectionError(err);
        
        // Nếu negotiate fail, thử lại với skipNegotiation (direct WebSocket)
        console.log('🔄 Retrying with direct WebSocket connection (skipNegotiation)...');
        this.tryConnectWithDirectWebSocket();
      });
  }

  /**
   * Fallback: Thử kết nối WebSocket trực tiếp (không negotiate)
   * Chỉ dùng khi negotiate fail
   */
  private tryConnectWithDirectWebSocket(): void {
    const currentToken = localStorage.getItem('access_token');
    
    const options: IHttpConnectionOptions = {
      withCredentials: true,
      accessTokenFactory: () => {
        const latestToken = localStorage.getItem('access_token');
        return latestToken ? latestToken : "";
      },
      // Thử direct WebSocket (skipNegotiation)
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets
    };

    // Tạo connection mới với direct WebSocket
    this.hubConnectionBuilder = new HubConnectionBuilder()
      .withUrl(`${apiUrl}notify`, {accessTokenFactory: () => {
        return localStorage.getItem("access_token") || "";
      }})
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          if (retryContext.previousRetryCount < 3) {
            return 3000 * Math.pow(2, retryContext.previousRetryCount);
          }
          return 30000;
        }
      })
      .build();

    this.setupSignalREventHandlers();

    // Thử kết nối direct WebSocket
    this.hubConnectionBuilder.start()
      .then(() => {
        console.log('✅ SignalR Connection started with direct WebSocket!');
        console.log('📡 Connection ID:', this.hubConnectionBuilder.connectionId);
        console.log('🔌 Transport: WebSocket (direct, no negotiate)');
        this.reconnectAttempts = 0;
        this.loadNotifications();
        
        // 🧪 TEST: Gửi thông báo test sau khi kết nối thành công
        // this.testSendNotification();
      })
      .catch(err => {
        console.error('❌ Direct WebSocket connection also failed:', err);
        this.handleConnectionError(err);
        console.error('⚠️ WebSocket không thể kết nối. Vui lòng kiểm tra:');
        console.error('   1. Load balancer có sticky sessions enabled?');
        console.error('   2. Proxy có hỗ trợ WebSocket?');
        console.error('   3. Firewall có chặn WebSocket connections?');
        console.error('   4. Server có hỗ trợ WebSocket?');
      });
  }

  /**
   * Lấy tên transport đang sử dụng
   */
  private getTransportName(): string {
    // SignalR không expose transport name trực tiếp
    // Nhưng có thể kiểm tra qua connection state
    return 'WebSocket';
  }


  /**
   * Thiết lập các event handlers cho SignalR connection
   */
  private setupSignalREventHandlers(): void {

    // Lắng nghe sự kiện khi kết nối bị đóng
    this.hubConnectionBuilder.onclose((error) => {
      if (error) {
        console.error('🔌 SignalR connection closed with error:', error);
        // Kiểm tra các lỗi phổ biến
        if (error.message) {
          const errorMsg = error.message.toLowerCase();
          if (errorMsg.includes('connection') && errorMsg.includes('not found')) {
            console.warn('⚠️ Connection ID không tồn tại trên server.');
            console.warn('   Có thể do: server restart, timeout, hoặc load balancer không có sticky sessions');
          }
          if (errorMsg.includes('websocket') && errorMsg.includes('proxy')) {
            console.warn('⚠️ WebSocket bị chặn bởi proxy. Long Polling sẽ được sử dụng khi reconnect.');
          }
        }
      } else {
        console.log('🔌 SignalR connection closed normally');
      }
    });

    // Lắng nghe sự kiện khi đang reconnect
    this.hubConnectionBuilder.onreconnecting((error) => {
      console.log('🔄 SignalR đang kết nối lại...', error);
      this.reconnectAttempts++;
    });

    // Lắng nghe sự kiện khi reconnect thành công
    this.hubConnectionBuilder.onreconnected((connectionId) => {
      console.log('✅ SignalR đã kết nối lại thành công! Connection ID:', connectionId);
      this.reconnectAttempts = 0;
    });

    // Lắng nghe message từ server
    this.hubConnectionBuilder.on('SendMessage', (res: any) => {
      console.log('📨 SendMessage received:', res);
      // Kiểm tra nếu res là chuỗi JSON thì parse nó
      if (typeof res === 'string') {
        try {
          res = JSON.parse(res);
          console.log('📨 Parsed JSON:', res);
          this.connectService.onUpdateDocument(res);
          this.handleNewNotification(res); // Xử lý thông báo mới
        } catch (e) {
          // Nếu không parse được thì giữ nguyên res
          console.log('⚠️ Không thể parse JSON từ res:', res);
        }
      } else {
        this.connectService.onUpdateDocument(res);
        this.handleNewNotification(res);
      }
    });

    // Lắng nghe callback từ server
    this.hubConnectionBuilder.on('CallBack', (res: any) => {
      console.log('📞 CallBack received:', res);
      this.loadNotifications();
    });
  }

  /**
   * Xử lý lỗi kết nối SignalR
   */
  private handleConnectionError(error: any): void {
    console.error('SignalR Connection Error Details:', {
      message: error?.message,
      name: error?.name,
      stack: error?.stack
    });

    if (error?.message) {
      const errorMsg = error.message.toLowerCase();
      
      // Kiểm tra các lỗi phổ biến
      if (errorMsg.includes('connection') && errorMsg.includes('not found')) {
        console.warn('⚠️ Connection ID không tồn tại. Có thể do:');
        console.warn('   - Server đã restart');
        console.warn('   - Connection timeout');
        console.warn('   - Load balancer không có sticky sessions');
        console.warn('   - Server từ chối kết nối do thiếu quyền (non-Admin account?)');
        console.warn('   → SignalR sẽ tự động reconnect với Connection ID mới');
        
        // Kiểm tra nếu là non-Admin account
        const userDataStr = localStorage.getItem('data');
        if (userDataStr) {
          try {
            const userData = JSON.parse(userDataStr);
            const isAdmin = userData?.code === 'ADMIN' || this.userInfo?.RoleMax === 1;
            if (!isAdmin) {
              console.warn('⚠️ [QUAN TRỌNG] Non-Admin account đang gặp lỗi kết nối!');
              console.warn('   → Có thể server đang từ chối SignalR connection cho non-Admin users');
              console.warn('   → Kiểm tra server SignalR hub authorization policy');
            }
          } catch (e) {
            // Ignore parse error
          }
        }
      }
      
      if (errorMsg.includes('websocket') && (errorMsg.includes('proxy') || errorMsg.includes('sticky sessions'))) {
        console.warn('⚠️ WebSocket không thể kết nối. Nguyên nhân có thể:');
        console.warn('   - Proxy/load balancer chặn WebSocket');
        console.warn('   - Load balancer không có sticky sessions enabled');
        console.warn('   - Firewall chặn WebSocket connections');
        console.warn('   - Server từ chối kết nối do thiếu quyền');
        console.warn('   → Đang thử các phương pháp kết nối WebSocket khác...');
      }
      
      if (errorMsg.includes('endpoint may not be a signalr endpoint')) {
        console.error('❌ Endpoint không phải là SignalR endpoint!');
        console.error('   Kiểm tra lại URL:', `${apiUrl}notify`);
      }

      // Kiểm tra lỗi authentication/authorization
      if (errorMsg.includes('unauthorized') || errorMsg.includes('forbidden') || errorMsg.includes('401') || errorMsg.includes('403')) {
        console.error('❌ [QUAN TRỌNG] Lỗi Authentication/Authorization!');
        console.error('   → Server có thể đang từ chối kết nối do:');
        console.error('     - Token không hợp lệ');
        console.error('     - Token hết hạn');
        console.error('     - Token thiếu claims/permissions');
        console.error('     - SignalR hub yêu cầu quyền Admin');
        console.error('   → Kiểm tra token và server authorization policy');
      }
    }
  }
 
  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    // Stop SignalR connection when component is destroyed
    if (this.hubConnectionBuilder) {
      this.hubConnectionBuilder.stop().then(() => {
        console.log('SignalR connection stopped');
      }).catch(err => {
        console.log('Error while stopping SignalR connection:', err);
      });
    }
  }

  openDialog(): void {
    this.dialogRef = this.dialog.open(DialogNewComponent, {
      width: '100%',
      height: 'auto',
      maxWidth: '500px',
      maxHeight: '600px',
      disableClose: true,
      data: {
        title: 'Thông báo',
        content: this.customContent,
        closeFn: () => this.closeDialog(), // Truyền hàm đóng modal vào Dialog
      },
    });
  }
  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  ChangeLang(lang: any) {
    const selectedLanguage = lang.target.value;

    localStorage.setItem('lang', selectedLanguage);

    this.translateService.use(selectedLanguage);

  }

  @HostListener('window:keydown', ['$event'])
  handleKey(event: KeyboardEvent) {
    if (event.key === '`') {
      event.preventDefault();   // không để ký tự ` chui vào input
      this.togglePhimTatDialog();
    }
  }

  togglePhimTatDialog() {
    if (this.dialogPhimTatRef) {
      // đang mở → đóng
      this.dialogPhimTatRef.close();
      this.dialogPhimTatRef = null;
      return;
    }

    // đang đóng → mở
    this.dialogPhimTatRef = this.dialog.open(DialogPhimtatComponent, {
      width: '1500px',
      height: 'auto',
      maxWidth: 'unset !important',
      panelClass: 'phimtat-dialog',
      autoFocus: false,
      restoreFocus: false,
    });

    // nếu dialog bị đóng bằng ESC, click ngoài, nút X...
    this.dialogPhimTatRef.afterClosed().subscribe(() => {
      this.dialogPhimTatRef = null;
    });
  }

  // Thêm các phương thức xử lý thông báo
  loadNotifications() {
    this.notificationRepo.getByPage().subscribe((res) => {
      if (res.meta?.error_code === 200) {
        console.log('loadNotifications', res.data);
        this.notifications = res.data;
        console.log('loadNotifications-this.notifications', this.notifications);
        this.updateUnreadCount();
      }
    });
  }

  handleNewNotification(notification: any) {
    this.notifications.unshift(notification);
    this.updateUnreadCount();
  }

  /**
   * 🧪 TEST: Gửi thông báo test để kiểm tra SignalR hoạt động
   * Method này sẽ simulate một notification từ server
   * Được gọi tự động sau khi SignalR kết nối thành công
   */
  private testSendNotification(): void {
    // Đợi 2 giây sau khi kết nối để đảm bảo connection đã ổn định
    setTimeout(() => {
      if (this.hubConnectionBuilder && this.hubConnectionBuilder.state === signalR.HubConnectionState.Connected) {
        console.log('🧪 [TEST] Đang gửi thông báo test...');
        
        // Tạo test notification với format giống notification thật
        const testNotification = {
          Id: 'test-' + Date.now(),
          Title: '🧪 Test Notification - Đăng nhập thành công!',
          Content: 'SignalR đã kết nối thành công. Bạn đã đăng nhập vào hệ thống.',
          IsRead: false,
          CreatedDate: new Date().toISOString(),
          Type: 'test',
          // Có thể thêm các field khác tùy theo cấu trúc notification của bạn
        };

        // Simulate nhận notification từ server (trigger event handler)
        console.log('🧪 [TEST] Test notification:', testNotification);
        this.handleNewNotification(testNotification);
        
        // Cũng có thể trigger qua ConnectService nếu cần
        // this.connectService.onUpdateDocument(testNotification);
        
        console.log('✅ [TEST] Test notification đã được thêm vào danh sách!');
        console.log('   → Kiểm tra icon thông báo trên header để xem test notification');
        console.log('   → Số thông báo chưa đọc:', this.unreadCount);
      } else {
        console.warn('⚠️ [TEST] SignalR chưa kết nối, không thể gửi test notification');
        console.warn('   → Connection state:', this.hubConnectionBuilder?.state);
      }
    }, 2000); // Đợi 2 giây
  }

  markAllAsRead() {
    // this.notifications.forEach(notification => notification.isRead = true);
    // this.updateUnreadCount();
    // // TODO: Gọi API để cập nhật trạng thái đã đọc
    this.notificationRepo.readAllNotification(this.notifications.map((item: any) => item.Id)).subscribe((res) => {
      if (res.meta?.error_code === 200) {
        this.loadNotifications();
        this.updateUnreadCount();
      }
    })
  }

  markAsRead(notification: any) {
    notification.isRead = true;
    this.updateUnreadCount();
    // TODO: Gọi API để cập nhật trạng thái đã đọc
  }

  updateUnreadCount() {
    this.unreadCount = this.notifications.filter(n => n.IsRead == false).length;
  }

  viewAllNotifications() {
    // TODO: Điều hướng đến trang xem tất cả thông báo
    this.notificationRepo.readAllNotification(this.notifications.map((item: any) => item.Id)).subscribe((res) => {
      if (res.meta?.error_code === 200) {
        this.loadNotifications();
        this.updateUnreadCount();
      }
    })
  }

  readNotification(noti: any) {
    if (noti.IsRead) {
      return;
    }
    else {
      this.notificationRepo.readNotification(noti.Id).subscribe((res) => {
        if (res.meta?.error_code === 200) {
          this.loadNotifications();
          this.updateUnreadCount();
        }
      })
    }
  }

  getImageUrl(value: any): string {
    const pick = Array.isArray(value) ? (value[0] || '') : (value || '');
    if (!pick) return '../../../../assets/images/svgs/Rectangle5.svg';
    if (typeof pick === 'string' && (pick.startsWith('http://') || pick.startsWith('https://'))) {
      return pick;
    }
    return `${apiUrl}uploads/images/${pick}`;
  }
}
